import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "../../../components/PageLayout/CarelonRx";
import SamlService from "../../../services/saml/SamlService";
import SecureSessionService from "../../../services/session/SecureSessionService";
import { useSession } from "../../../contexts/SessionContext";
import { useFlow } from "../../../contexts/FlowContext";
import "../../../styles/CarelonRx/usernameSuccess.css";

const UsernameSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const { sessionData } = useSession();
  const { getFlowData, resetFlow } = useFlow();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const newUsername = getFlowData('newUsername');

  useEffect(() => {
    if (!sessionData?.sessionId) {
      navigate("/");
    }
  }, [sessionData, navigate]);

  const handleLogin = async () => {
    if (isLoading || !sessionData?.sessionId) return;

    const username = newUsername ;
    
    if (!username) {
      setError("Username is missing. Please try again.");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      
      await SamlService.sendAuthResponseAndRedirect(
        sessionData.sessionId,
        username,
      );
      SecureSessionService.clearSession();
      resetFlow();

    } catch (err: any) {
      setError(err.message || "Failed to redirect. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <PageLayout bannerTitle="Update Username">
          <div className="success-page-container">
            <div className="success-content">
              <div className="success-icon-wrapper">
                <img 
                  src="/assets/carelonRx/images/Check Circle.svg" 
                  alt="Success" 
                  className="success-icon"
                />
              </div>

              <h1 className="success-title">Your username has been updated.</h1>

              {error && (
                <div className="success-error-message">
                  <span>{error}</span>
                </div>
              )}

              <button
                onClick={handleLogin}
                disabled={isLoading}
                className="success-login-button"
              >
                {isLoading ? (
                  <>
                    <span className="button-spinner"></span>
                    <span>Redirecting...</span>
                  </>
                ) : (
                  "Log In"
                )}
              </button>
            </div>
          </div>
    </PageLayout>
  );
};

export default UsernameSuccessPage;
